import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import type { MarkerSet } from '@go-modules/interfaces/markers/marker';
import { clientSettings } from 'go-modules/models/common/client.settings';

interface CanUpdateResponse {
	can_update: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class NgxTagSetService {
	constructor (
		private readonly http: HttpClient
	) {}

	public getById (id: number): Observable<MarkerSet> {
		return this.http.get<MarkerSet>(`${clientSettings.GoReactV2API}/tag_sets/${id}`);
	}

	public canUpdate (id: number): Observable<boolean> {
		return this.http.get<CanUpdateResponse>(`${clientSettings.GoReactV2API}/tag_sets/${id}/can-update`).pipe(
			map((response) => !!response?.can_update)
		);
	}
}
